import { useContext } from "react";
import useSWR from "swr";
import { environment } from "../config/environment";
import { SearchInvoiceReceivableResponseDetailedModel } from "@attelas/shared";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

export function useSearchInvoiceReceivables(searchStr: string) {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<SearchInvoiceReceivableResponseDetailedModel[]>(
    searchStr ? `${environment.apiUrl}/api/invoices/receivables/query?name=${encodeURIComponent(searchStr)}` : null,
    (url) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to search receivables, please try again later", "error");
      },
    }
  );

  return {
    result: data,
    isLoading,
    isError: !!error,
  };
}
